import React, {useState} from 'react';
import OeTip from './OeTip';
import {docUrl, printDocument} from './api';

// Ergebnis eines Lieferlaufs (Original `renderDeliverResult`, 4504, und
// `loadDeliverDocs`, 4538; ABGLEICH I4): welche Lieferscheine entstanden sind,
// ob eine Fehlmengen-Datei am Auftrag hängt, was im Kommentar steht — und die
// frisch erzeugten Lieferschein-PDFs zum Ansehen und Drucken.

export default function DeliverResult({result, docs, orderRef, orderId, kommState, canPrint, onToast}) {
    const [busy, setBusy] = useState(null);

    if (!result) {
        return null;
    }

    const shipments = result.shipments || [];
    const sf = result.shortfalls || [];
    const xlsx = result.xlsx;

    const herunterladen = (d) => {
        const a = document.createElement('a');
        a.href = docUrl(orderRef, d.docId, {type: 'order', id: orderId, download: true});
        a.download = d.name;
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    const drucken = async (d) => {
        const printer = (kommState && (kommState.preferred || (kommState.printers || []).find((p) => /lager/i.test(p))))
            || null;
        if (!printer) {
            onToast('Kein Drucker bekannt — bitte im Schritt „Komischein" (4) einmal drucken');
            return;
        }
        setBusy(d.docId);
        try {
            const j = await printDocument(orderRef, {documentId: d.docId, printerName: printer, quantity: 1});
            if (j.dryRun) {
                onToast(`Trockenlauf: ${j.message || 'Es wurde nichts gedruckt.'}`);
            } else {
                onToast(j.ok ? `✓ an „${j.printerName}" geschickt` : 'Druck fehlgeschlagen: ' + (j.error || 'unbekannt'));
            }
        } catch (e) {
            onToast('Druck fehlgeschlagen: ' + (e.response?.data?.error || e.message), {variant: 'danger'});
        } finally {
            setBusy(null);
        }
    };

    return (
        <div className="deliverbox">
            {shipments.map((s, i) => (
                <div className="dr-line" key={s.number || i}>
                    🚚 <b>{s.number}</b>
                    <span className="muted">
                        {s.warehouseName} · {s.positions} Pos.{s.beistellung ? ' · Beistellung' : ''}
                        {(s.veAnpassungen || []).length
                            ? ` · VE-Regel: ${s.veAnpassungen.length} Pos. abgerundet`
                            : ''}
                        {s.finalized && s.finalized.dryRun ? ' · Festschreiben im Trockenlauf' : ''}
                        {s.finalized && s.finalized.ok === false ? ' · ⚠ nicht festgeschrieben' : ''}
                    </span>
                </div>
            ))}

            {xlsx && xlsx.ok ? (
                <div className="dr-line">
                    📄 <b>{xlsx.name}</b>
                    <span className="muted">
                        an den Auftrag gehängt ({sf.length} Fehlmenge{sf.length === 1 ? '' : 'n'})
                    </span>
                </div>
            ) : null}

            {sf.length > 0 && !(xlsx && xlsx.ok) ? (
                <div className="dr-line" style={{color: 'var(--warn)'}}>
                    ⚠ {sf.length} Fehlmenge(n) — Excel konnte nicht angehängt werden
                    {xlsx && xlsx.error ? `: ${xlsx.error}` : ''}
                </div>
            ) : null}

            {!sf.length ? (
                <div className="dr-line" style={{color: 'var(--ok)'}}>✓ Keine Fehlmengen — alles lieferbar.</div>
            ) : null}

            {result.comment && result.comment.ok ? (
                <>
                    <div className="dr-line">💬 Kommentar im Auftrag hinterlegt</div>
                    <pre className="dr-comment">{result.comment.text || ''}</pre>
                </>
            ) : null}

            {result.comment && !result.comment.ok ? (
                <div className="dr-line" style={{color: 'var(--warn)'}}>
                    ⚠ Kommentar konnte nicht geschrieben werden: {result.comment.error || ''}
                </div>
            ) : null}

            {(docs || []).length ? (docs || []).map((d) => (
                <div className="dr-pdf" key={d.docId}>
                    <div className="kommhead">
                        <span className="lbl">{d.name}</span>
                        <span className="sp"/>
                        {canPrint ? (
                            <OeTip tip="Schickt den Lieferschein an den zuletzt benutzten Lager-Drucker. Der Ausdruck läuft physisch im Lager — im Testmodus wird nur protokolliert.">
                                <button
                                    type="button"
                                    className="actbtn"
                                    disabled={busy === d.docId}
                                    onClick={() => drucken(d)}
                                >
                                    🖨 an Drucker
                                </button>
                            </OeTip>
                        ) : null}
                        <OeTip tip="Lädt den Lieferschein als PDF herunter.">
                            <button type="button" className="actbtn" onClick={() => herunterladen(d)}>⬇ PDF</button>
                        </OeTip>
                    </div>
                    <iframe
                        className="kommframe"
                        src={docUrl(orderRef, d.docId, {type: 'order', id: orderId})}
                        title={d.name}
                    />
                </div>
            )) : (
                <div className="muted" style={{fontSize: 12}}>Lieferschein-PDFs werden erzeugt…</div>
            )}
        </div>
    );
}
